import {createRouter, createWebHistory} from 'vue-router';
import Login from './components/Login.vue';
import Calling from './components/Calling.vue'

// const UserLogin = () => import('@/components/Login')

const routes = [

    {
        path: '/',
        name: 'Sign-Up',
        component: Login,
        meta: {
            requiresAuth: false ,
            redirectIfAuthenticated: true,// Add meta field to indicate protected route
        }
    },
    {
        path: '/report',
        name: 'Calling-Form',
        component: Calling,
        meta: {
            requiresAuth: true,
            redirectIfAuthenticated: false, // Add meta field to indicate protected route
        }
    }

];


const router = createRouter({
    history: createWebHistory(),
    routes,
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('authToken');

  if (to.meta.requiresAuth) {
    if (token) {
      // User is authenticated
      next();
    } else {
      // User is not authenticated, redirect to login
      next('/'); // Change to '/login' if your login page URL is different
    }
  } else if (to.name === 'Sign-Up' && token) {
    // If user is authenticated and trying to access login page, redirect to '/report'
    next('/report');
  } else {
    // Non-protected route, allow access
    next();
  }
});


export default router;

